// @credit: 76a97b1cd4349534e19fb23cf80c4a0f1b1502418015de1e9d68b95c44bc36d433ed49b8
//
// Aphilaty PWA — DomainMismatchModal (AD-10)
//
// Non-blocking warning shown when the requester's email domain doesn't match
// the org's configured domain. Two exits: acknowledge and proceed, or go back
// to edit the email.

interface Props {
  orgDomain: string;
  onConfirm: () => void;
  onGoBack:  () => void;
}

export function DomainMismatchModal({ orgDomain, onConfirm, onGoBack }: Props) {
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000, padding: 16,
    }}>
      <div style={{
        background: 'var(--color-bg)',
        borderRadius: 'var(--radius-lg)',
        padding: 24,
        maxWidth: 400,
        width: '100%',
        boxShadow: '0 4px 24px rgba(0,0,0,0.3)',
      }}>
        <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 10 }}>
          Email domain mismatch
        </h2>
        <p style={{ fontSize: 13, color: 'var(--color-text-secondary)', lineHeight: 1.6, marginBottom: 16 }}>
          This organization expects email addresses ending in{' '}
          <strong>@{orgDomain}</strong>. Your email uses a different domain.
        </p>
        <p style={{ fontSize: 13, color: 'var(--color-text-secondary)', lineHeight: 1.6, marginBottom: 20 }}>
          If your email is correct and you are authorized to represent this organization,
          you can still submit — the org admins will review your request.
        </p>
        <div style={{ display: 'flex', gap: 10 }}>
          <button
            type="button"
            className="btn btn-primary"
            style={{ flex: 1 }}
            onClick={onConfirm}
          >
            Yes, my email is correct
          </button>
          <button
            type="button"
            className="btn btn-outline"
            style={{ flex: 1 }}
            onClick={onGoBack}
          >
            Go back
          </button>
        </div>
      </div>
    </div>
  );
}
